<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <period-selector v-model="period"></period-selector>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.document_date="{ item }">
                {{ new Date(item.document_date) | date }}
            </template>
            <template v-slot:item.supplier_id="{ item }">
                {{ _.get(supplier, 'name', 'Nespecificat') }}
            </template>
            <template v-slot:item.amount_with_vat="{ item }">
                {{ item.amount_with_vat | price }}
            </template>
            <template v-slot:item.payments="{ item }">
                {{ Math.abs((parseFloat(item.amount_with_vat) - parseFloat(item.due_amount))) | price }}
            </template>
            <template v-slot:item.due_amount="{ item }">
                {{ item.due_amount | price }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="item.type === 'MAINTENANCE'"
                    small
                    class="mr-2"
                    @click="$router.push({name: 'vehicle-maintenances-edit', params: {id: item.id}})"
                >
                    mdi-eye
                </v-icon>
                <v-icon
                    v-else-if="item.type === 'EXPENSE'"
                    small
                    class="mr-2"
                    @click="$router.push({name: 'vehicle-expenses-edit', params: {id: item.id}})"
                >
                    mdi-eye
                </v-icon>
                <v-icon
                    v-else-if="item.type === 'MAINTENANCE'"
                    small
                    class="mr-2"
                    @click="$router.push({name: 'vehicle-fuels-edit', params: {id: item.id}})"
                >
                    mdi-eye
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import PeriodSelector from "Components/common/PeriodSelector";
    export default {
        extends: SmartTable,
        components: {
            PeriodSelector
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            },
            supplier: {
                type: Object,
                required: false
            }
        },
        data: () => ({
            title: 'Fisa furnizorului',
            headers: [
                { text: 'Data', value: 'document_date' },
                { text: 'Nr. Doc.', value: 'document_no' },
                { text: 'Furnizor', value: 'supplier_id', sortable: false },
                { text: 'Valoare intrari', value: 'amount_with_vat' },
                { text: 'Plati', value: 'payments', sortable: false },
                { text: 'Sold', value: 'due_amount', sortable: false },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            },
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()]
        }),

        watch: {
            period: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                let { data, meta } = await this.$db.Expense
                    .append('due_amount')
                    .where('supplier_id', this.id)
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                    .get()
                this.items = data
                this.meta = meta
            }
        },
    };
</script>
